import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { About } from './Pages/About';
import { Home } from './Pages/Home';
import { Navbar } from './Components/Navbar';

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
